import { EBlankFormOtherFeeType } from '../enums/blank_form.enum';

export interface IBlankFormOtherFee {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  deletedBy: string;
  blankFormId: number;
  code: EBlankFormOtherFeeType;
  name: string;
  receivedPercent: number;
  receivedValue: number;
  totalAmount: number;
  data: any;
  isDefault: boolean;
}
